// eslint-disable-next-line import/no-anonymous-default-export
export default  [
    {
        id: 1,
        title: 'Accueil',
        path : '/',      
    },
    {
        id: 2,
        title: 'Prestations',
        path : '/service',      
    },
    {
        id: 3,
        title: 'Philosophie',
        path : '/philosophy',      
    },
    {
        id: 4,
        title: 'Offres',
        path : '/offers',      
    },
    {
        id: 5,
        title: 'Nos marques',
        path : '/marks',      
    },
    {
        id: 6,
        title: 'Nous trouver',
        path : '/find-us',      
    },
]